import React, { Component } from 'react'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { TRACK_STATE_DIFFICULTY, TRACK_STATE_STATUS } from './config/constants';
import Defs from './components/Defs';
import './assets/styles/App.scss';
import Map from './components/Map';
import CrossRoadsList from './components/CrossRoadsList';
import MapPopup from './components/popup/MapPopup';
import Legend from './components/UI/Legend/Legend';
import { getServerMapData } from './helpers/network';
import {
	getInitialParamsForContainer,
	getMapCoordsForMove,
	getMapTopOffset, getMarkersVisibility,
	getPanProps,
	getPopupContent,
	prepareTracksDataFromServer, setMapCoordsData,
} from './helpers/map';
import MapBackground from './components/MapBackground';
import Svg from './components/UI/Icons/Svg';
import LegendMobileButton from './components/UI/Legend/LegendMobileButton';
import { mapHeight, mapWidth } from './config/defaults';
import { isMobile } from './helpers/common';
import ZoomIcons from './components/UI/ZoomIcons';
import Loading from './components/Loading';
import TracksDebug from "./components/debug/TracksDebug";
import { DEBUG } from "./config/app";
// import { liftsData, tracksData } from "./data/addedStaticData";

export const AppContext = React.createContext({ liftsData: null, markersShow: null });
const urlParams = new URLSearchParams(window.location.search);
const isFromApp = urlParams.get('isFromApp');

class App extends Component {
	constructor(props) {
		super(props);
		this.mapRef = React.createRef();
		this.state = {
			tracksState: TRACK_STATE_STATUS,
			tracksData: null,
			liftsData: null,
			tracksDataRevision: 1,
			popupCoords: { x: 400, y: 200 },
			mapCoords: { x: 0, y: 0, scale: 1 },
			activeLabelRef: null,
			activeLabelWidth: 0,
			activeTrackId: '',
			showPopup: false,
			popupContent: null,
			showFoodMarkers: false,
			showRentMarkers: false,
			showMedicalMarkers: true,
			showSkatingMarkers: false,
			showSkiMarkers: false,
			isMobile: isMobile(),
			showLegendOnMobile: false,
			activeLiftId: null,
			isLoading: true
		};
	}

	async componentDidMount() {
		// Завантажити збережений стан маркерів з localStorage
		const savedMarkersState = this.loadMarkersState();
		if (savedMarkersState) {
			this.setState(savedMarkersState);
		}

		const serverData = await getServerMapData();

		const initMap = () => {
			const { minScale, maxScale, initialScale, defaultPositionX, defaultPositionY } = getInitialParamsForContainer(isFromApp);
			this.setState({
				tracksData: prepareTracksDataFromServer(serverData.tracksData),
				liftsData: serverData.liftsData,
				isLoading: false,
				waitingTracksData: serverData.waitingTracksData,
				mapCoords: { x: defaultPositionX, y: defaultPositionY, scale: initialScale, minScale, maxScale },
			}, () => {
				if (this.mapRef) {
					this.mapRef.current.context.dispatch.setTransform(defaultPositionX, defaultPositionY, initialScale, 0);
					this.getPopupCoordinatesFromRef();
				}
			});
		};

		initMap();

		window.onresize = () => {
			this.setState({ isMobile: isMobile() }, () => this.getPopupCoordinatesFromRef());
			// initMap();
		};
	}

	changeTrackStateToDifficulty = () => {
		this.setState({ tracksState: TRACK_STATE_DIFFICULTY, tracksDataRevision: Math.random() })
	};

	changeTrackStateToStatus = () => {
		this.setState({ tracksState: TRACK_STATE_STATUS, tracksDataRevision: Math.random() })
	};

	//For debug
	toggleTrackVisibility = trackName => {
		const newTracksList = { ...this.state.tracksData };
		newTracksList[trackName].isShow = !newTracksList[trackName].isShow;

		this.setState({
			tracksData: newTracksList,
			tracksDataRevision: Math.random()
		});
	};

	//For debug
	toggleTrackStatus = (trackName, status) => {
		const newTracksList = { ...this.state.tracksData };
		newTracksList[trackName].status = status;

		this.setState({ tracksData: newTracksList, tracksDataRevision: Math.random() });
	};

	toggleLegendOnMobile = () => {
		this.setState(prevState => ({ showLegendOnMobile: !prevState.showLegendOnMobile, showPopup: false }));
	};

	movePopup = (x, y, width) => {
		this.setState({ popupCoords: { x, y }, activeLabelWidth: width, showPopup: true });
	};

	getPopupCoordinatesFromRef = () => {
		if (this.state.activeLabelRef) {
			const dim = this.state.activeLabelRef.getBoundingClientRect();
			this.movePopup(dim.x, dim.y - getMapTopOffset() + window.scrollY, dim.width);
		}
	};

	moveToTrackById = trackId => {
		if (this.mapRef) {
			const trackEl = document.getElementById(trackId);
			this.onClickOnLabel(trackEl.querySelector('.label'), trackId, this.mapRef.current.context.dispatch.setTransform);
		}
	};

	moveToLiftById = liftId => {
		if (this.mapRef) {
			const liftEl = document.getElementById('Lift' + liftId);
			const positionFunction = this.mapRef.current.context.dispatch.setTransform;

			const { mapCoords } = this.state;
			const { mapX, mapY, scale } = getMapCoordsForMove(liftEl.querySelector('.lift-label'), mapCoords, this.state.isMobile);

			this.setState({ showPopup: false, showLegendOnMobile: !this.state.isMobile, activeLiftId: liftId }, () => {
				positionFunction(mapX, mapY, mapCoords.scale, 300);
			});

			setTimeout(() => {
				this.setState({
					activeLabelRef: null,
					tracksDataRevision: Math.random(),
					activeTrackId: null,
					popupContent: null,
					mapCoords: setMapCoordsData(mapCoords, mapX, mapY, scale)
				});
			}, scale > 1 ? 300 : 0);
		}
	};

	onChangeTracksState = newTracksState => {
		if (newTracksState !== this.state.tracksState) {
			const showMarkers = newTracksState === TRACK_STATE_DIFFICULTY;
			this.setState({
				tracksState: newTracksState,
				tracksDataRevision: Math.random(),
				showLegendOnMobile: false,
				showFoodMarkers: showMarkers,
				showRentMarkers: showMarkers,
				showSkatingMarkers: showMarkers,
				showSkiMarkers: showMarkers,
			}, () => this.saveMarkersState());
		}
	};

	onClickOnLabel = (labelRef, trackId, positionFunction) => {
		if (this.state.activeTrackId === trackId)
			return false;

		const { mapCoords } = this.state;
		const { mapX, mapY, scale } = getMapCoordsForMove(labelRef, mapCoords, this.state.isMobile);

		this.setState({ showPopup: false, showLegendOnMobile: !this.state.isMobile }, () => {
			positionFunction(mapX, mapY, mapCoords.scale, 300);
		});

		setTimeout(() => {
			this.setState({
				activeLabelRef: labelRef,
				activeTrackId: trackId,
				showPopup: true,
				popupContent: getPopupContent(trackId, this.state.tracksData[trackId]),
				mapCoords: setMapCoordsData(mapCoords, mapX, mapY, scale)
			}, () => {
				this.getPopupCoordinatesFromRef();
			});
		}, scale > 1 ? 300 : 0);
	};

	onZoomChange = data => {
		const { mapCoords } = this.state;
		this.setState({
				mapCoords: setMapCoordsData(mapCoords, data.positionX, data.positionY, data.scale)
			},
			() => {
				this.getPopupCoordinatesFromRef();
			}
		);
	};

	// Зберегти стан маркерів в localStorage
	saveMarkersState = () => {
		const markersState = {
			showFoodMarkers: this.state.showFoodMarkers,
			showRentMarkers: this.state.showRentMarkers,
			showMedicalMarkers: this.state.showMedicalMarkers,
			showSkatingMarkers: this.state.showSkatingMarkers,
			showSkiMarkers: this.state.showSkiMarkers,
			tracksState: this.state.tracksState, // Зберігаємо також status/difficulty
		};
		try {
			localStorage.setItem('bukovel-markers-state', JSON.stringify(markersState));
		} catch (e) {
			// Ignore localStorage errors
		}
	};

	// Завантажити стан маркерів з localStorage
	loadMarkersState = () => {
		try {
			const saved = localStorage.getItem('bukovel-markers-state');
			return saved ? JSON.parse(saved) : null;
		} catch (e) {
			return null;
		}
	};

	changeMarkersVisibility = key => {
		this.setState(
			prevState => ({ [key]: !prevState[key], tracksDataRevision: Math.random() }),
			() => this.saveMarkersState()
		);
	};

	onMapPanning = data => {
		this.getPopupCoordinatesFromRef();
		this.setState({ mapCoords: setMapCoordsData(this.state.mapCoords, data.positionX, data.positionY, data.scale) });
	};

	onZoomButtonClick = (e, zoomFunction) => {
		this.setState({ showPopup: false }, () => {
				zoomFunction(e);
				setTimeout(() => {
					this.getPopupCoordinatesFromRef();
				}, 200)
			}
		);
	};

	render() {
		const {
			tracksState,
			tracksData,
			liftsData,
			tracksDataRevision,
			showPopup,
			popupContent,
			isMobile
		} = this.state;

		const markersVisibility = getMarkersVisibility({ ...this.state });
		const { initialScale, minScale, maxScale } = getInitialParamsForContainer(isFromApp);

		return (
			<div className="map-container" style={{ height: window.innerHeight }}>
				{this.state.isLoading && <Loading/>}

				<TransitionGroup>
					{showPopup && (
						<CSSTransition
							key="popup"
							timeout={50}
							classNames="popup"
						>
							<MapPopup
								coords={this.state.popupCoords}
								onClose={() => this.setState({ showPopup: false, activeTrackId: '', activeLabelRef: null })}
								content={popupContent}
								centerWidth={this.state.activeLabelWidth}
								isMobile={isMobile}
							>
								{popupContent}
							</MapPopup>
						</CSSTransition>
					)}
				</TransitionGroup>

				<TransformWrapper
					onZoomChange={this.onZoomChange}
					onWheel={this.onZoomChange}
					onPanning={data => this.onMapPanning(data)}
					options={{ centerContent: true, limitToBounds: true, maxScale, minScale }}
					pan={getPanProps(showPopup)}
					enablePadding={false}
					enablePanPadding={false}
					scalePadding={{ disabled: true, size: 0 }}
					wheel={{ step: 15, disableLimitsOnWheel: false }}
					defaultScale={initialScale}
				>
					{({ setTransform, zoomIn, zoomOut }) => (
						<>
							<TransformComponent ref={this.mapRef}>
								<Svg viewBox={`${mapWidth} ${mapHeight}`} width="100vw" height={mapHeight} id="mapObject">
									<Defs/>
									<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
										<MapBackground isFromApp={isFromApp}/>

										{tracksData && (
											<AppContext.Provider value={{ liftsData, markersVisibility: markersVisibility, tracksState }}>
												<Map
													tracksState={tracksState}
													revision={tracksDataRevision}
													onClickOnLabel={(event, labelRef, trackId) => this.onClickOnLabel(labelRef, trackId, setTransform)}
													serverTracksData={tracksData}
													activeLiftId={this.state.activeLiftId}
												/>

												{tracksData && <CrossRoadsList tracksData={tracksData} tracksState={tracksState}/>}
											</AppContext.Provider>
										)}
									</g>
								</Svg>
							</TransformComponent>

							<ZoomIcons
								zoomInFunction={zoomIn}
								zoomOutFunction={zoomOut}
								minScale={minScale}
								maxScale={maxScale}
								scale={this.state.mapCoords.scale}
								onClick={this.onZoomButtonClick}
							/>
						</>
					)}
				</TransformWrapper>

				{isMobile && <LegendMobileButton
					onClick={this.toggleLegendOnMobile}
					showLegendOnMobile={this.state.showLegendOnMobile}/>
				}

				{!DEBUG && (
					<TransitionGroup>
						{((!isMobile || (isMobile && this.state.showLegendOnMobile)) && tracksData) && (
							<CSSTransition
								key="legend"
								timeout={{ enter: 300, exit: 200 }}
								classNames="legend-animation"
							>
								<Legend
									tracksData={tracksData}
									liftsData={liftsData}
									waitingTracksData={this.state.waitingTracksData}
									tracksState={tracksState}
									onChangeTrackState={newTracksState => this.onChangeTracksState(newTracksState)}
									onChangeMarkersVisibility={key => this.changeMarkersVisibility(key)}
									markersVisibility={markersVisibility}
									onClickOnTrack={trackId => this.moveToTrackById(trackId)}
									onClickOnLift={liftId => this.moveToLiftById(liftId)}
									onClose={this.toggleLegendOnMobile}
								/>
							</CSSTransition>
						)}
					</TransitionGroup>
				)}

				{DEBUG && tracksData && <TracksDebug
					onChangeToStatus={this.changeTrackStateToStatus}
					onChangeToDifficulty={this.changeTrackStateToDifficulty}
					tracksData={tracksData}
					onToggleTrack={trackName => this.toggleTrackVisibility(trackName)}
					onToggleTrackStatus={(trackName, value) => this.toggleTrackStatus(trackName, value)}
					trackState={tracksState}
				/>}
			</div>
		);
	}
}

export default App;
